<div id="overview-tile-footer" *ngIf="!fromPdfExport">
  <button id="view-report-button" mat-button (click)="viewDataReport(metricType)">View data report
    <img alt="Chevron Symbol" src="assets/purple-chevron.svg" class="chevron-symbol"/>
  </button>
</div>
